import React from 'react';
import AscendingIcon from '../Icons/ascending';
import DescendingIcon from '../Icons/descending';

export function SortableTh({
  label,
  columnKey,
  headerSort,
  onSortDescending,
  onSortAscending,
  className = 'py-2 pr-4',
  scope = 'col',
  innerLabelClassName = 'text-xs font-medium leading-normal',
}) {
  return (
    <th scope={scope} className={className}>
      <div className="flex gap-1">
        <div className={innerLabelClassName}>{label}</div>
        <div className="flex w-[31.8px] items-center">
          <div className="cursor-pointer" onClick={() => onSortDescending(columnKey)} role="presentation">
            <DescendingIcon isActive={columnKey === headerSort.column && headerSort.order === 1} />
          </div>
          <div className="cursor-pointer" onClick={() => onSortAscending(columnKey)} role="presentation">
            <AscendingIcon isActive={columnKey === headerSort.column && headerSort.order === 0} />
          </div>
        </div>
      </div>
    </th>
  );
}

export default SortableTh;
